import { classNames } from "zeta-dom-react";
import { IconText } from ".";

const icons = {
    info: 'infoFilled',
    warn: 'warningFilled',
    success: 'successFilled',
} as const;

export interface StatusBarProps {
    variant: 'info' | 'warn' | 'success';
}

export function StatusBar(props: React.PropsWithChildren<StatusBarProps>) {
    return (
        <div className={classNames('eac-status-bar eac-text', { variant: props.variant })}>
            <IconText icon={icons[props.variant]}>{props.children}</IconText>
        </div>
    );
}
